import { render, staticRenderFns } from "./LabelSelectComplex.vue?vue&type=template&id=7ec2f1ae"
import script from "./LabelSelectComplex.vue?vue&type=script&lang=js"
export * from "./LabelSelectComplex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports